<template>
  <el-dialog
    title="输入要添加的地址"
    :visible.sync="dialogVisible"
    :modal="false"
    width="400px"
    :close-on-click-modal="false"
    :append-to-body="true">
    <div class="flex-row justify-between item-center" style="flex-wrap:wrap">
      <span class="propject_detail_info_table_cell col-1" style="margin-bottom:10px">
        地址：
        <el-input v-model="setOption['地址']" placeholder="地址" size="mini"/>
      </span>
      <span class="propject_detail_info_table_cell col-1">
        备注：
        <el-input v-model="setOption['备注']" placeholder="备注" size="mini"/>
      </span>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">取 消</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirm">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      setOption: { 地址: '', 备注: '' },
    }
  },
  methods: {
    async open() {
      this.dialogVisible = true
      this.setOption = { 地址: '', 备注: '' }
    },
    async confirm() {
      this.dialogVisible = false
      if (this.setOption.地址||this.setOption.备注) this.$emit('addAddress',this.setOption)
    },
  },
}
</script>
